// extracted by mini-css-extract-plugin
export default {"noResult":"autocompleteList_noResult__+KfxV","item":"autocompleteList_item__uqpeP"};